import { Box, LinearProgress, linearProgressClasses } from "@mui/material";
import { createColorWithAlphaChannel } from "app/theme/helpers/createColorWithAlphaChannel";

export const RouterSuspenseFallback = () => (
  <Box
    alignItems="center"
    display="flex"
    flex="1 1 auto"
    justifyContent="center"
  >
    <LinearProgress
      sx={{
        [`& .${linearProgressClasses.bar}`]: { bgcolor: "text.primary" },
        bgcolor: (theme) =>
          createColorWithAlphaChannel(
            theme.vars.palette.text.primaryChannel,
            0.16,
          ),
        maxWidth: 320,
        width: 1,
      }}
    />
  </Box>
);
